
import React from 'react';
import { Mail, Phone, Linkedin, Download } from 'lucide-react';
import { Link } from 'react-router-dom';
import ToolsDropdown from '@/components/ToolsDropdown';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-gradient-to-b from-white to-gray-50 text-black">
      {/* Glowing line */}
      <div className="h-1 w-full bg-gradient-to-r from-primary/60 via-primary to-primary/60 shadow-lg shadow-primary/20"></div>
      
      <div className="container mx-auto px-4 py-8">
        {/* Main Footer Content */}
        <div className="flex flex-col lg:flex-row lg:justify-between lg:items-start gap-8">
          {/* Logo and About Section */}
          <div className="lg:flex-[2]">
            <div className="flex items-center mb-4">
              <img 
                src="/lovable-uploads/9660a1c7-e321-4122-b380-58c44ed97180.png" 
                alt="AD Email Lab Logo" 
                className="h-10 mr-3"
                width="40" 
                height="40"
                loading="lazy"
              />
              <span className="text-lg font-bold text-primary">AD Email Lab</span>
            </div>
            <p className="text-gray-700 leading-relaxed mb-4">
              AD Email Lab is the personal website of Antonio Dimoski, a CRM and Digital Marketing Specialist.
              Here you'll find practical tools, articles, projects, and insights covering CRM, email marketing,
              web development, marketing automation, and digital marketing.
            </p>
            <ToolsDropdown />
          </div>

          {/* Contact Info Section */}
          <div className="lg:flex-[1]">
            <h3 className="text-lg font-bold mb-4 text-primary">Get In Touch</h3>
            <div className="space-y-3">
              <div className="flex items-start text-gray-700">
                <Mail className="h-4 w-4 mr-3 mt-0.5 text-primary flex-shrink-0" />
                <p>16-ta Makedonska Brigada 4/2, Skopje 1000</p>
              </div>
              <div className="flex items-center text-gray-700">
                <Phone className="h-4 w-4 mr-3 text-primary flex-shrink-0" />
                <a href="tel:+38975280030" className="hover:text-primary transition-colors font-medium">
                  +389-75-280-030
                </a>
              </div>
              <div className="flex items-center text-gray-700">
                <Mail className="h-4 w-4 mr-3 text-primary flex-shrink-0" />
                <a href="mailto:antonio.dimoski@ad-email-lab.com" className="hover:text-primary transition-colors font-medium">
                  antonio.dimoski@ad-email-lab.com
                </a>
              </div>
            </div>

            {/* Social Links */}
            <div className="mt-6 flex space-x-3">
              <a 
                href="https://www.linkedin.com/in/antonio-dimoski/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="p-2 bg-white rounded-full shadow-md hover:shadow-lg hover:bg-primary hover:text-white transition-all duration-300 text-primary"
              >
                <span className="sr-only">LinkedIn</span>
                <Linkedin className="w-4 h-4" />
              </a>
              <a 
                href="mailto:antonio.dimoski@ad-email-lab.com" 
                className="p-2 bg-white rounded-full shadow-md hover:shadow-lg hover:bg-primary hover:text-white transition-all duration-300 text-primary"
              >
                <span className="sr-only">Email</span>
                <Mail className="w-4 h-4" />
              </a>
              <a 
                href="https://drive.google.com/file/d/1sJYm5jD7mCYcXBuum_W7Sedj9HQOtMvv/view" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="p-2 bg-white rounded-full shadow-md hover:shadow-lg hover:bg-primary hover:text-white transition-all duration-300 text-primary"
              >
                <span className="sr-only">Download CV</span>
                <Download className="w-4 h-4" />
              </a>
            </div>

          </div>
        </div>

        {/* Bottom footer */}
        <div className="mt-6 pt-6 border-t border-gray-200">
          <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-3">
            <p className="text-gray-600 text-center md:text-left text-sm">
              © {currentYear} AD Email Lab. All rights reserved.
            </p>
            <div className="flex justify-center md:justify-end space-x-4">
              <Link to="/privacy-policy" className="text-gray-600 hover:text-primary transition-colors text-sm">
                Privacy Policy
              </Link>
              <Link to="/terms-of-service" className="text-gray-600 hover:text-primary transition-colors text-sm">
                Terms of Service
              </Link>
              <Link to="/cookie-policy" className="text-gray-600 hover:text-primary transition-colors text-sm">
                Cookies
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
